import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getHideSelfView } from '../../../../base/settings/functions.any';
import { setVisibleRemoteParticipants } from '../../../actions.any';
const usePaging = ({ type }) => {
    const dispatch = useDispatch();
    const { remoteParticipants, tileViewMode } = useSelector((state) => state['features/filmstrip']);
    const { localScreenShare } = useSelector((state) => state['features/base/participants']);
    const disableSelfView = useSelector((state) => getHideSelfView(state));
    const [currentPage, setCurrentPage] = useState(0);
    const localCount = disableSelfView ? 0 : localScreenShare ? 2 : 1;
    let participantPage = tileViewMode - localCount;
    const totalPage = Math.ceil(remoteParticipants.length / participantPage);
    const isShowNext = currentPage + 1 < totalPage;
    const isShowPrev = currentPage !== 0;
    const handleNext = () => {
        const currentPageNew = currentPage + 1;
        const visibleParticipantPage = participantPage - 1;
        const endIndex = Math.min(currentPageNew * participantPage + visibleParticipantPage, remoteParticipants.length - 1);
        const startIndex = endIndex - visibleParticipantPage;
        setCurrentPage(currentPageNew);
        dispatch(setVisibleRemoteParticipants(startIndex, endIndex));
    };
    const handlePrev = () => {
        const currentPageNew = currentPage - 1;
        const visibleParticipantPage = participantPage - 1;
        const endIndex = Math.min(currentPageNew * participantPage + visibleParticipantPage, remoteParticipants.length - 1);
        const startIndex = endIndex - visibleParticipantPage;
        setCurrentPage(currentPageNew);
        dispatch(setVisibleRemoteParticipants(startIndex, endIndex));
    };
    useEffect(() => {
        if (currentPage !== 0)
            setCurrentPage(0);
        else {
            const visibleParticipantPage = participantPage - 1;
            const endIndex = Math.min(0 * participantPage + visibleParticipantPage, remoteParticipants.length - 1);
            const startIndex = 0;
            dispatch(setVisibleRemoteParticipants(startIndex, endIndex));
        }
    }, [tileViewMode]);
    useEffect(() => {
        if (currentPage + 1 > totalPage) {
            dispatch(setVisibleRemoteParticipants(Math.max(remoteParticipants.length - participantPage, 0), Math.max(remoteParticipants.length - 1, 0)));
            setCurrentPage(prev => Math.max(prev - 1, 0));
        }
    }, [totalPage]);
    return {
        currentPage,
        isShowNext,
        isShowPrev,
        handleNext,
        handlePrev,
        participantPage,
        totalPage
    };
};
export default usePaging;
